//Vendors
window.jquery = window.$ = require('jquery');
import 'bootstrap/dist/js/bootstrap';
import 'datatables.net';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min.js';
import 'x-editable/dist/bootstrap3-editable/js/bootstrap-editable.js';
import 'select2/dist/js/select2.js';
import 'inputmask/dist/jquery.inputmask.js';
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.js';
import 'jquery-validation/dist/jquery.validate.js';
import 'clipboard';

//Our libs
import './lib/SmartNotification.min.js';

//Datepicker ru setup
$.fn.datepicker.dates['ru'] = {
    days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    daysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    monthsShort: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    today: "Сегодня",
    clear: "Очистить",
    format: "dd.mm.yyyy",
    weekStart: 1
};

//X-editable buttons setup
$.fn.editableform.buttons =
    '<button type="submit" class="btn btn-primary btn-sm editable-submit">'+
    '<i class="fas fa-check"></i>'+
    '</button>'+
    '<button type="button" class="btn btn-default btn-sm editable-cancel">'+
    '<i class="fas fa-times"></i>'+
    '</button>';
